import { type RefObject, useEffect } from 'react';

/**
 * 要素が画面に入った時にコールバックを実行する
 * @param ref 要素のref
 * @param onIntersect コールバック
 * @param enabled 有効化されているかどうか
 * @param rootMargin ルートマージン
 * @returns void
 */
export const useIntersection = (
  ref: RefObject<HTMLElement | null>,
  onIntersect: () => void,
  { enabled = true, rootMargin = '0px' }: { enabled?: boolean; rootMargin?: string } = {},
) => {
  useEffect(() => {
    if (!enabled) return;

    const target = ref.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          onIntersect();
        }
      },
      { rootMargin },
    );

    observer.observe(target);

    // クリーンアップで確実に接続を解除
    return () => observer.disconnect();

    // onIntersect を依存配列に入れる場合は、呼び出し側で useCallback 必須
  }, [ref, onIntersect, enabled, rootMargin]);
};
